import React, { useState } from "react";
import { GoogleGenerativeAI } from "@google/generative-ai";

const genAI = new GoogleGenerativeAI(
  process.env.REACT_APP_GEMINI_API_KEY
);

const model = genAI.getGenerativeModel({
  model: "gemini-1.5-flash",
});

const Chatbot = () => {
  const [messages, setMessages] = useState([
    {
      role: "bot",
      text: "Hi 👋 I'm your AI assistant. How can I help you?",
    },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMsg = { role: "user", text: input };
    setMessages((prev) => [...prev, userMsg]);
    setInput("");
    setLoading(true);

    try {
      const result = await model.generateContent({
        contents: [
          {
            role: "user",
            parts: [{ text: userMsg.text }],
          },
        ],
      });

      const response = result.response.text();

      setMessages((prev) => [
        ...prev,
        { role: "bot", text: response },
      ]);
    } catch (error) {
      console.error(error);
      setMessages((prev) => [
        ...prev,
        {
          role: "bot",
          text: "Sorry 😢 Something went wrong. Please try again.",
        },
      ]);
    }

    setLoading(false);
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.header}>
        <i className="bi bi-robot"></i> AI Chatbot
      </div>

      <div style={styles.chatBody}>
        {messages.map((msg, i) => (
          <div
            key={i}
            style={{
              ...styles.message,
              alignSelf:
                msg.role === "user" ? "flex-end" : "flex-start",
              background:
                msg.role === "user" ? "#0d6efd" : "#f1f1f1",
              color: msg.role === "user" ? "#fff" : "#000",
            }}
          >
            {msg.text}
          </div>
        ))}
        {loading && (
          <div style={{ fontSize: "12px", color: "#888" }}>
            AI is typing...
          </div>
        )}
      </div>

      <div style={styles.inputArea}>
        <input
          type="text"
          className="form-control"
          placeholder="Type your message..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && sendMessage()}
        />
        <button
          className="btn btn-primary"
          onClick={sendMessage}
        >
          <i className="bi bi-send-fill"></i>
        </button>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    width: "360px",
    height: "520px",
    borderRadius: "12px",
    boxShadow: "0 0 15px rgba(0,0,0,0.2)",
    display: "flex",
    flexDirection: "column",
    background: "#fff",
    overflow: "hidden",
  },
  header: {
    background: "#0d6efd",
    color: "#fff",
    padding: "12px",
    fontWeight: "bold",
    textAlign: "center",
    fontSize: "16px",
  },
  chatBody: {
    flex: 1,
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    overflowY: "auto",
    background: "#fafafa",
  },
  message: {
    padding: "8px 12px",
    borderRadius: "15px",
    maxWidth: "80%",
    fontSize: "14px",
    lineHeight: "1.4",
  },
  inputArea: {
    display: "flex",
    gap: "6px",
    padding: "10px",
    borderTop: "1px solid #ddd",
  },
};

export default Chatbot;
